/*
 * Base controller for virtual patch drilldowns - helps to share common functions and
 * variables that are used in the view (on $scope) and the service methods invocations
 * that are needed to populate those variables
 */
;(function () {
  'use strict'

  angular
    .module('contrast.virtual-patch')
    .controller(
      'BaseVirtualPatchCtrl',
      function BaseVirtualPatchCtrl(
        $scope,
        LanguagesService,
        virtualPatchService,
        TechnologyService,
        TranslationUtils,
        VIRTUAL_PATCH
      ) {
        'ngInject'

        var me
        var _validLanguages

        this.$onInit = function () {
          me = this
          _validLanguages = []

          angular.extend(me, {
            init: init,
            addCriteria: addCriteria,
            removeApplication: removeApplication
          })

          angular.extend($scope, {
            techs: [],
            apps: [],
            languages: [],
            languagesTranslate: [],
            pre_populated: false,

            objects: VIRTUAL_PATCH.ATTRIBUTES.SELECT,
            conditions: VIRTUAL_PATCH.CONDITIONS.SELECT,
            patch: {}
          })

          angular.extend($scope, {
            addCriteria: addCriteria,
            deleteCriteria: deleteCriteria,
            validateForm: validateForm,
            addApplication: addApplication,
            removeApplication: removeApplication,
            getLangaugeDisplayValue: getLangaugeDisplayValue
          })
        }

        function init() {
          return _loadValidLanguages().then(_loadApps).then(_loadTechs)
        }

        function addApplication(model) {
          $scope.patch.apps = virtualPatchService.addApplication(
            $scope.patch.apps,
            model
          )
        }

        function removeApplication(model) {
          $scope.patch.apps = virtualPatchService.removeApplication(
            $scope.patch.apps,
            model
          )
        }

        function addCriteria() {
          $scope.patch.criterias.push({
            attribute: $scope.objects[0].value,
            operand: $scope.conditions[0].value,
            value: ''
          })
        }

        function deleteCriteria(criteria) {
          var idx = $scope.patch.criterias.indexOf(criteria)
          if (idx > -1) {
            $scope.patch.criterias.splice(idx, 1)
          }
        }

        function validateForm() {
          return virtualPatchService.isValidVirtualPatch($scope.patch)
        }

        function _loadValidLanguages() {
          return virtualPatchService
            .getValidLanguages()
            .then(function (languages) {
              _validLanguages = languages
              $scope.languages = languages
              $scope.languagesTranslate = TranslationUtils.toSentence(languages)
            })
        }

        function _loadApps() {
          return ($scope.appPropmise = virtualPatchService
            .getApplications(_validLanguages)
            .then(function (applications) {
              $scope.apps = applications
            }))
        }

        function _loadTechs() {
          $scope.technologiesPromise = TechnologyService.getTechs(
            _validLanguages
          ).then(function (techs) {
            $scope.techs = techs
          })
        }

        function getLangaugeDisplayValue(language) {
          return LanguagesService.getLanguage(language).display
        }
      }
    )
})()
